module.exports = __webpack_public_path__ + "typicons.107d077d609efa723916.svg";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/typicons.font/src/font/typicons.svg
// module id = ../../../../typicons.font/src/font/typicons.svg
// module chunks = styles